import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 Large Text */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600">
            404
          </h1>
        </div>

        {/* Error Message */}
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-xl text-gray-300 mb-6">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <p className="text-gray-400">
            Don't worry, even the best horse farms lose track of things sometimes! 🐎
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4 md:space-y-0 md:space-x-4 md:flex md:justify-center">
          <Link
            to="/"
            className="inline-block bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105"
          >
            Go Home
          </Link>
          
          <Link
            to="/features"
            className="inline-block bg-gray-800 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-all duration-300 border border-gray-700"
          >
            View Features
          </Link>
          
          <Link
            to="/contact"
            className="inline-block bg-gray-800 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-all duration-300 border border-gray-700"
          >
            Contact Support
          </Link>
        </div>

        {/* Popular Pages */}
        <div className="mt-16 pt-8 border-t border-gray-800">
          <h3 className="text-lg font-semibold text-white mb-6">
            Popular Pages
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <Link 
              to="/features" 
              className="text-blue-400 hover:text-blue-300 hover:underline transition-colors"
            >
              Features
            </Link>
            <Link 
              to="/pricing" 
              className="text-blue-400 hover:text-blue-300 hover:underline transition-colors"
            >
              Pricing
            </Link>
            <Link 
              to="/about" 
              className="text-blue-400 hover:text-blue-300 hover:underline transition-colors"
            >
              About Us
            </Link>
            <Link 
              to="/support" 
              className="text-blue-400 hover:text-blue-300 hover:underline transition-colors"
            >
              Support
            </Link>
            <Link 
              to="/security" 
              className="text-blue-400 hover:text-blue-300 hover:underline transition-colors"
            >
              Security
            </Link>
            <Link 
              to="/blog" 
              className="text-blue-400 hover:text-blue-300 hover:underline transition-colors"
            >
              Blog
            </Link>
            <Link 
              to="/careers" 
              className="text-blue-400 hover:text-blue-300 hover:underline transition-colors"
            >
              Careers
            </Link>
            <Link 
              to="/contact" 
              className="text-blue-400 hover:text-blue-300 hover:underline transition-colors"
            >
              Contact
            </Link>
          </div>
        </div>

        {/* BarnBills Logo/Branding */}
        <div className="mt-12 text-gray-500">
          <p className="text-sm">
            © 2025 BarnBills LLC - Complete Horse Farm Management
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage; 